export function getPgSelectorUrlString(selectors){ 
    return   `PGSelectionType=${selectors.PGSelectionType}&PGTransactionVia=${selectors.PGSelectionType}&GatewayNumber=${selectors.GatewayNumber}&OrchestratorNumber=${selectors.OrchestratorNumber}&isFromApp=${selectors.isFromApp}`;
} 




